import { useState, useEffect, useContext } from "react";
import MainLayouts from "../../../Layout/MainLayouts";
import { ReactComponent as ArrowLeftSquare } from "bootstrap-icons/icons/arrow-left-square-fill.svg";
import Spinner from "../../spinner/Spinner";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import ApiServices from "../../../api/ApiServices";
import { toast } from "react-toastify";
import { handleError } from "../../../components/utils/AuthenticationCheck";
import CurrencyFormatter from "../../../components/utils/CurrencyFormatter";
// import { ReactComponent as PencilSquare } from "bootstrap-icons/icons/pencil-square.svg";
// import { ReactComponent as Trash } from "bootstrap-icons/icons/trash.svg";
import { ReactComponent as CardList } from "bootstrap-icons/icons/card-list.svg";
import { ReactComponent as PlusSquareFill } from "bootstrap-icons/icons/plus-square-fill.svg";
import AxiosApiCall from "../../../api/AxiosApiCall";
import DataTable from "react-data-table-component";
import CustomStyles from "../../../components/utils/CustomStyles";
// import formatDate from "../../../components/utils/DateFormatter";
import { AuthContext } from "../../../AuthProvider/AuthProvider";

import formatDate from "../../../components/utils/DateFormatter";
const GetIncentiveById = () => {
  const [branchDetails, setBranchDetails] = useState({
    summary: {},
    incentives: [],
  });
  const [branch_id, setBranchId] = useState("");
  const [loading, setLoading] = useState(false);
  const [funding, setFunding] = useState(false);
  const [confirmationLoading, setConfirmationLoading] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const { permissions } = useContext(AuthContext);

  const navigate = useNavigate();
  const location = useLocation();
  const { id } = location.state || {};

  useEffect(() => {
    if (id) {
      setBranchId(id);
    }
  }, [id]);



  //axios api encryption call
  const axios = AxiosApiCall();

  const fetchBranchDetails = async () => {
    if (!branch_id) return;
    setLoading(true);
    try {
      const authData = JSON.parse(localStorage.getItem("auth"));
      const token = authData?.token;
      if (!token) throw new Error("No access token found.");

      const response = await axios.get(ApiServices.getBranchOpeIncentives, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        params: { branch_id },
        withCredentials: true,
      });

      const { status, message, data } = response.data;
      if (status === 200) {
        setBranchDetails(data);
        toast.success(message, { toastId: "incentive-fetch-success" });

      } else {
        handleError({ response: { status, data: { message } } }, navigate);
      }
    } catch (error) {
      handleError(error, navigate);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (branch_id) {
      fetchBranchDetails();
    }
  }, [branch_id]);


  // Handle branch activation
  const handleDeleteIncentives = async (branchId) => {
    const formData = {
      branch_id: branchId,
    };
    try {
      setConfirmationLoading(true);
      const authData = JSON.parse(localStorage.getItem("auth"));
      const token = authData?.token;
      if (!token) {
        throw new Error("No access token found.");
      }
      const response = await axios.delete(ApiServices.deleteBranchOpeCreateIncentives, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: formData,
        withCredentials: true,
      });
      const { status, message } = response.data;
      if (status === 200) {
        toast.success(message, { toastId: "incentive-deleted-success" });
        await fetchBranchDetails();
      } else {
        handleError({ response: { status, data: { message } } }, navigate);
      }
    } catch (error) {
      handleError(error, navigate);
    } finally {
      setConfirmationLoading(false);
    }
  };


  // Handle Delete Confirmation
  const handleDeleteConfirmation = (branchId) => {
    setConfirmationLoading(true);
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      setConfirmationLoading(false);
      if (result.isConfirmed) {
        handleDeleteIncentives(branchId);
      }
    });
  };


  // fund incentive
  const handleFundIncentive = async () => {
    const { value: formValues } = await Swal.fire({
      title: "Fund Branch Incentive",
      html: `
      <input id="amount" type="number" placeholder="Amount"
        class="w-full px-4 py-2 border border-gray-300 rounded-md mb-3" />
      <input id="description" type="text" placeholder="Description"
        class="w-full px-4 py-2 border border-gray-300 rounded-md mb-3" />
        <input id="effective_date" type="date"
  class="w-full px-4 py-2 border border-gray-300 rounded-md mb-3" />
      <select id="category"
        class="w-full px-4 py-2 border border-gray-300 rounded-md mb-3">
          <option value="">Select Category</option>
          <option value="performance">Performance</option>
          <option value="sales_target">Sales Target</option>
          <option value="customer_service">Customer Service</option>
          <option value="special_achievement">Special Achievement</option>
          <option value="monthly_bonus">Monthly Bonus</option>
          <option value="quarterly_bonus">Quarterly Bonus</option>
          <option value="annual_bonus">Annual Bonus</option>
          <option value="other">Other</option>
      </select>
      <textarea id="notes" placeholder="Notes"
        class="w-full px-4 py-2 border border-gray-300 rounded-md mb-1 resize-none h-24"></textarea>
    `,

      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: "Fund",
      preConfirm: () => {
        const amount = parseFloat(document.getElementById("amount").value);
        const description = document.getElementById("description").value;
        const category = document.getElementById("category").value;
        const notes = document.getElementById("notes").value;
        const effective_date = document.getElementById("effective_date").value;

        if (!amount || !description) {
          Swal.showValidationMessage(`Amount and description are required`);
          return;
        }

        return { amount, description, category, notes, effective_date };
      },
    });

    if (formValues) {
      try {
        setFunding(true);
        const authData = JSON.parse(localStorage.getItem("auth"));
        const token = authData?.token;
        if (!token) throw new Error("No access token found.");

        const formData = {
          branch_id,
          amount: formValues.amount,
          description: formValues.description,
          category: formValues.category,
          notes: formValues.notes,
          ...(formValues.effective_date && { effective_date: formValues.effective_date }),
        };


        // console.log("pay load ", formData);

        const response = await axios.post(ApiServices.BranchOpeCreateIncentives, formData, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        });

        const { status, message } = response.data;
        if (status === 200) {
          toast.success(message, { toastId: "incentive-created-success" });
          await fetchBranchDetails();
        } else {
          handleError({ response: { status, data: { message } } }, navigate);
        }
      } catch (error) {
        handleError(error, navigate);
      } finally {
        setFunding(false);
      }
    }
  };




  const columns = [
    {
      name: "Reference",
      selector: (row) => row.reference || "NOT AVAILABLE",
      sortable: true,
      width: "250px",
    },
    {
      name: "Amount",
      selector: (row) => row.amount || "NOT AVAILABLE",
      sortable: true,
      width: "150px",
    },
    {
      name: "Description",
      selector: (row) => row.description || "NOT AVAILABLE",
      sortable: true,
      width: "200px",
    },
    {
      name: "Status",
      cell: (row) => (
        <span className={row.status === "pending" ? "text-orange1" : "text-dash4"}>
          {row.status.toUpperCase()}
        </span>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "Created Date",
      selector: (row) =>
        row.created_at ? formatDate(row.created_at) : "NOT AVAILABLE",
      sortable: true,
      width: "200px",
    }


  ];

  const ExpandableComponent = ({ data }) => {
    return (
      <div className="p-4 bg-gray-50 rounded-md text-sm text-gray-700 grid gap-2">
        <p>
          <span className="font-semibold">Description:</span>{" "}
          {data.description || "No description available"}
        </p>
        <p>
          <span className="font-semibold">Funded  By:</span>{" "}
          {data.creator?.fullname || "NOT AVAILABLE"}
        </p>
        {/* <p>
          <span className="font-semibold">Paid Date and Time :</span>{" "}
          {data.paid_at ? formatDate(data.paid_at) : "Not Paid"}
        </p> */}
        {/* <p>
          <span className="font-semibold">Created At:</span>{" "}
          {data.created_at ? formatDate(data.created_at) : "NOT AVAILABLE"}
        </p>
        <p>
          <span className="font-semibold">Updated At:</span>{" "}
          {data.updated_at ? formatDate(data.updated_at) : "NOT AVAILABLE"}
        </p> */}
      </div>
    );
  };



  const handleFilter = (e) => {
    setFilterText(e.target.value);
    setResetPaginationToggle(!resetPaginationToggle);
  };

  const filteredItems = branchDetails.incentives.filter((item) =>
    Object.keys(item).some((key) =>
      item[key]?.toString().toLowerCase().includes(filterText.toLowerCase())
    )
  );



  return (
    <MainLayouts>
      <div className="relative sm:rounded-lg py-6 w-full">
        <section className="w-full pr-[3%] pt-3 my-3 bg-gray-100">
          <nav className="bg-gray-200 py-0 px-4 rounded-lg">
            <ol className="list-none p-0 inline-flex mb-2">
              <li className="flex items-center">
                <p className="text-darkGreen3 pr-2">Operations Branch</p>
                <ChevronRightIcon />
              </li>
              <li className="flex items-center">
                <p className="text-darkGreen3 pr-2">Incentives</p>
                <ChevronRightIcon />
              </li>
              <li className="flex items-center">
                <p className="text-orange1">Detail</p>
              </li>
            </ol>
          </nav>
        </section>

        {loading ? (
          <Spinner loading={loading} />
        ) : (
          <section className="text-gray-600 body-font">
            <div className="container">
              <div className="flex justify-end mb-3">
                {permissions.some(permission => permission.name === 'branch.fund_wallet') && (
                  <button
                    onClick={handleFundIncentive}
                    disabled={funding}
                    className="mx-2 w-full sm:w-auto text-dGrey3 bg-dash focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                  >
                    <span className="flex justify-center sm:justify-start mx-2">
                      <PlusSquareFill className="mr-2" />
                      Fund
                    </span>
                  </button>
                )}
                {permissions.some(permission => permission.name === 'branch.incentive.view') && (
                  <Link
                    to="/operations/branch/incentives/stat" state={{ id: branch_id }}
                    className="mx-2 w-full sm:w-auto text-dGrey3 bg-dash4 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                  >
                    <span className="flex justify-center sm:justify-start mx-2">
                      <CardList className="mr-2" />
                      Statistc
                    </span>
                  </Link>
                )}
                <Link
                  to="/operations/branch/list"
                  className="mx-2 w-full sm:w-auto text-dGrey3 bg-black2 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                >
                  <span className="flex justify-center sm:justify-start mx-2">
                    <ArrowLeftSquare className="mr-2" />
                    Back
                  </span>
                </Link>

              </div>

              <div className="grid grid-cols-12 gap-4">
                <div className="col-span-12 lg:col-span-12 p-2">
                  <div className="flex items-center border-dash border p-1 rounded-lg border-l-4">
                    <section className="body-font w-full">
                      <div className="container px-2">
                        <div className="w-full flex flex-wrap">
                          <div className="w-full px-4">
                            <div className="flex border-tx border-gray-200 py-2">
                              <span className="text-gray-500">Total Incentives</span>
                              <span className="ml-auto text-dash">
                                {CurrencyFormatter(branchDetails.summary.total_incentives || 0)}
                              </span>
                            </div>
                            {/* <div className="flex border-t border-gray-200 py-2">
                              <span className="text-gray-500">Total Paid</span>
                              <span className="ml-auto text-dash">
                                {CurrencyFormatter(branchDetails.summary.paid_incentives || 0)}
                              </span>
                            </div> */}
                            {/* <div className="flex border-t border-gray-200 py-2">
                              <span className="text-gray-500">Total Pending</span>
                              <span className="ml-auto text-dash">
                                {CurrencyFormatter(branchDetails.summary.pending_incentives || 0)}
                              </span>
                            </div> */}
                            {/* <div className="flex border-t border-gray-200 py-2">
                              <span className="text-gray-500">Approved Incentives</span>
                              <span className="ml-auto text-dash">
                                {CurrencyFormatter(branchDetails.summary.approved_incentives || 0)}
                              </span>
                            </div> */}


                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-12 gap-4">
                <div className="col-span-12 lg:col-span-12 p-2">
                  {/* <div className="flex items-center border-dash border p-1 rounded-lg border-l-4"> */}
                  <section className="body-font w-full">
                    <div className="relative w-full sm:w-1/2 mb-4 sm:mb-0">
                      <input
                        type="search"
                        className="block w-full px-3 py-2 text-md text-gray-900 border border-gray-300 rounded-lg bg-gray-50 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                        placeholder="Search"
                        value={filterText}
                        onChange={handleFilter}
                      />
                    </div>
                    <div className="container px-2 mt-4">
                      <DataTable
                        columns={columns}
                        data={filteredItems}
                        pagination
                        highlightOnHover
                        striped
                        customStyles={CustomStyles}
                        noDataComponent={<div>No Incentive found</div>}
                        expandableRows
                        expandableRowsComponent={ExpandableComponent}
                      />
                    </div>
                  </section>
                  {/* </div> */}
                </div>
              </div>
            </div>
          </section>
        )}
      </div>
    </MainLayouts>
  );
};

export default GetIncentiveById;
